// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Payer } from "./Payer.ts";

export const serviceIntroductionEntryPointTypeEnum = {
  SERVICE_INTRODUCTION: "SERVICE_INTRODUCTION",
} as const;

export type ServiceIntroductionEntryPointTypeEnumKey =
  (typeof serviceIntroductionEntryPointTypeEnum)[keyof typeof serviceIntroductionEntryPointTypeEnum];

export const serviceIntroductionTypeEnum = {
  VANCE_SERVICE_INTRODUCTION: "VANCE_SERVICE_INTRODUCTION",
} as const;

export type ServiceIntroductionTypeEnumKey =
  (typeof serviceIntroductionTypeEnum)[keyof typeof serviceIntroductionTypeEnum];

export type ServiceIntroduction = {
  /**
   * @description Active Medicaid coverage details. Absent when no active coverage is found.
   */
  activeMedicaid?: Payer;
  /**
   * @description Active Medicare coverage details. Absent when no active coverage is found.
   */
  activeMedicare?: Payer;
  /**
   * @type string
   */
  entryPointType: ServiceIntroductionEntryPointTypeEnumKey;
  /**
   * @type string
   */
  memberId: string;
  /**
   * @type string
   */
  state: string;
  /**
   * @type string
   */
  type: ServiceIntroductionTypeEnumKey;
  /**
   * @type string, date
   */
  workRequirementLastUpdatedDate?: string | null;
  /**
   * @type string
   */
  workspaceId: string;
};
